import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Spin, Result, Typography, Progress } from "antd";
import "../../components/Footer/Footer.css";
import { Stripe } from "stripe";
import { inviteTeamMember } from "../../Utils/SupabaseServices/UserDatabase";

const { Title, Paragraph } = Typography;

const TeamPaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isVerifying, setIsVerifying] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [countdown, setCountdown] = useState(5);
  const [verificationComplete, setVerificationComplete] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState<'success' | 'failed' | null>(null);

  // Handle countdown and tab closing
  useEffect(() => {
    if (verificationComplete && countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);

      return () => clearInterval(timer);
    } else if (verificationComplete && countdown === 0) {
      // Close current tab and communicate with parent
      if (window.opener) {
        window.opener.postMessage({
          type: 'PAYMENT_COMPLETED',
          status: paymentStatus,
          sessionData: location.state?.paymentData
        }, '*');
        window.close();
      }
    }
  }, [verificationComplete, countdown, paymentStatus]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get("session_id");
    
    if (sessionId) {
      verifyTeamPayment(sessionId);
      
    } else {
      setIsVerifying(false);
      setError("No payment session found. Please try again.");
      setPaymentStatus('failed');
      setVerificationComplete(true);
    }
  }, [location]);

  const verifyTeamPayment = async (sessionId: string) => {
    try {
      setIsVerifying(true);
      const stripe_key = "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";
    //   const stripe_key = "sk_test_51MavLUHoyGmWWOpV7qCfWE1isX1NJesvdB22be4zzQ0WIrVqlZVblGb76RaHM9kmrdGz8ac3hhYZB9gB82EFcMTK004TMF1nId"
      const stripe = new Stripe(stripe_key!, {
        apiVersion: '2022-11-15',
      }); 

      const session = await stripe.checkout.sessions.retrieve(sessionId);

      // Check for payment status - a session can be "complete" with different payment statuses
      if (session.payment_status === "paid" || session.status === "complete") {
        // Get email from URL params for the invitation
        const urlParams = new URLSearchParams(window.location.search);
        const email = urlParams.get("email");
        const userId = urlParams.get("user_id");

        setPaymentStatus('success');
        setVerificationComplete(true);
        setIsVerifying(false)

        // Store session data for the parent window
        location.state = { 
          paymentData: session,
          email: email,
          userId: userId
        };
      } else {
        setIsVerifying(false);
        setError("Payment verification failed. Status: " + session.payment_status);
        setPaymentStatus('failed');
        setVerificationComplete(true);
      }
    } catch (error) {
      console.error("Error verifying team payment:", error);
      setIsVerifying(false);
      setError("An error occurred while verifying your payment. Please contact support.");
      setPaymentStatus('failed');
      setVerificationComplete(true);
    }
  };

  const renderContent = () => {
    if (isVerifying) {
      return (
        <div style={{ textAlign: "center", padding: "40px", backgroundColor: "#27282b", borderRadius: "8px" }}>
          <Spin size="large" />
          <Title level={3} style={{ marginTop: "20px", color: "white" }}>Verifying team payment</Title>
          <Paragraph style={{ marginTop: "10px", color: "#666" }}>
            Please wait while we process your transaction...
          </Paragraph>
        </div>
      );
    }

    if (error) {
      return (
        <Result
          status="error"
          title={<span style={{ color: "white" }}>Payment Failed</span>}
          subTitle={
            <div>
              <span style={{ color: "#f0f0f0" }}>{error}</span>
              <div style={{ marginTop: "20px" }}>
                <Progress
                  type="circle"
                  percent={countdown * 20}
                  format={() => countdown}
                  status={paymentStatus === 'failed' ? 'exception' : 'success'}
                />
                <p style={{ marginTop: "10px", color: "#666" }}>
                  This window will close automatically
                </p>
              </div>
            </div>
          }
          style={{ background: "#27282b", padding: "30px", borderRadius: "8px" }}
        />
      );
    }

    return (
      <Result
        status="success"
        title={<span style={{ color: "white" }}>Payment Successful!</span>}
        subTitle={
          <div>
            <span style={{ color: "#f0f0f0" }}>Your team upgrade is complete.</span>
            <div style={{ marginTop: "20px" }}>
              <Progress
                type="circle"
                percent={countdown * 20}
                format={() => countdown}
                status="success"
              />
              <p style={{ marginTop: "10px", color: "#666" }}>
                This window will close automatically
              </p>
            </div>
          </div>
        }
        style={{ background: "#27282b", padding: "30px", borderRadius: "8px" }}
      />
    );
  };

  return (
    <div className="auth-container">
      <div className="navbar_container">
        <a href="/" className="navbar_logo-link w-nav-brand" aria-label="home">
          <div className="logo-text" style={{ marginLeft: "-25%" }}>
            <img
              className="homepage-icon-logo"
              src="/assets/NewLogo-removebg.png"
              alt="search bubble logo"
            />
          </div>
        </a>
      </div>

      <div 
        style={{
          maxHeight: "85vh",
          margin: "0 auto",
          padding: "0px 20px",
          textAlign: "center",
          borderRadius: "8px",
          color: "white",
        }}
      >
        {renderContent()}
      </div>
    </div>
  );
};

export default TeamPaymentSuccess; 